module.exports = {
	"COMMON": {
		"LEGAL_MENTIONS": {
			"fr": "Mentions légales",
			"en": "Legal mentions"
		},
		"COOKIE_CONSENT": {
			"fr": "Nous utilisons des cookies pour une meilleure expérience utilisateur.",
			"en": "We use cookies for better user experience."
		},
		"COOKIE_CONSENT_ACCEPT": {
			"fr": "Accepter",
			"en": "Accept"
		},
		"COOKIE_CONSENT_DISMISS": {
			"fr": "Fermer",
			"en": "Dismiss"
		},
		"COOKIE_CONSENT_DISMISS_MORE": {
			"fr": "Désactive les cookies",
			"en": "Cookies will be disabled"
		},
		"HEADLINE": {
			"fr": "Interprètes d'hier et d'aujourd'hui",
			"en": "Interpretations, past and present"
		},
		"HEADLINE_1": {
			"fr": "Interprètes d'hier",
			"en": "Interpretations,"
		},
		"HEADLINE_2": {
			"fr": "et d'aujourd'hui",
			"en": "past and present"
		},
		"SUMMARY": {
			"fr": "Forgotten Records est un label français de musique classique. Il est né d’une passion de la musique et de son interprétation.",
			"en": "Forgotten Records is a French label specialised in classical music. We are driven by our passion for music and interpretation."
		},
		"KEYWORDS": {
			"fr": "musique clasique re-edition reedition rare historique enregistrement",
			"en": "classical music reissue rare historical recording"
		},
		"LANGUAGE_LOCALE": {
			"fr": "français",
			"en": "english"
		},
		"LANGUAGE": {
			"fr": {
				"fr": "français",
				"en": "anglais"
			},
			"en": {
				"fr": "french",
				"en": "english"
			}
		},
		"SEE_MORE": {
			"fr": "Voir",
			"en": "See more"
		},
		"BACK": {
			"fr": "Retour",
			"en": "Back"
		},
		"LEARN_MORE": {
			"fr": "En savoir davantage",
			"en": "Learn more"
		},
		"MENU": {
			"HOME": {
				"fr": "Accueil",
				"en": "Home"
			},
			"CATALOGUE": {
				"fr": "Catalogue",
				"en": "Catalogue",
				"ALL": {
					"fr": "tout le catalogue",
					"en": "full catalogue"
				},
				"REISSUE": {
					"fr": "Interprètes d'hier",
					"en": "Historical recordings"
				},
				"PRODUCTION": {
					"fr": "Interprètes d'aujourd'hui",
					"en": "Contemporary artists"
				},
				"SPECIAL": {
					"fr": "Parmi les interprètes d'aujourd'hui",
					"en": "Special releases"
				}
			},
			"WRITINGS": {
				"fr": "Ecrits",
				"en": "Writings",
				"LONG": {
					"fr": "Ecrits sur la musique",
					"en": "Writings about music"
				},
				"ALL": {
					"fr": "Tous les écrits",
					"en": "All the writings"
				}
			},
			"ABOUT": {
				"fr": "Qui sommes-nous",
				"en": "About us",
				"PRESENTATION": {
					"fr": "Présentation",
					"en": "Presentation"
				},
				"PRESS": {
					"fr": "Dans la presse",
					"en": "In the press"
				},
				"PARTNERS": {
					"fr": "Partenaires",
					"en": "Partners"
				},
				"CONTACT": {
					"fr": "Contact",
					"en": "Contact"
				}
			}
		},
		"TAXONOMY": {
			"active": {
				"fr": "publié",
				"en": "published"
			},
			"type": {
				"fr": "types",
				"en": "types",
				"VALUES": {
					"reissue": {
						"fr": "Interprètes d'hier",
						"en": "Historical recording"
					},
					"production": {
						"fr": "Interprètes d'aujourd'hui",
						"en": "Contemporary artists"
					},
					"special": {
						"fr": "Parmi les interprètes d'aujourd'hui",
						"en": "Special releases"
					}
				}
			},
			"tag": {
				"fr": "thématiques",
				"en": "subjects",
				"VALUES": {
					"philosophy": {
						"fr": "Philosophie et musique",
						"en": "Philosophy and music"
					},
					"composers": {
						"fr": "Les compositeurs et leurs oeuvres",
						"en": "Composers and their work"
					},
					"artists": {
						"fr": "Les interprètes",
						"en": "Artists"
					},
					"miscellaneous": {
						"fr": "Varia",
						"en": "Miscellaneous"
					}
				}
			},
			"language": {
				"fr": "langue",
				"en": "language",
				"VALUES": {
					"fr": {
						"fr": "français",
						"en": "French"
					},
					"en": {
						"fr": "anglais",
						"en": "English"
					}
				}
			},
			"author": {
				"fr": "auteurs",
				"en": "authors"
			},
			"composer": {
				"fr": "compositeurs",
				"en": "composers"
			},
			"soloist": {
				"fr": "solistes",
				"en": "artists"
			},
			"conductor": {
				"fr": "chefs d'orchestre",
				"en": "conductors"
			},
			"instrument": {
				"fr": "instruments",
				"en": "instruments"
			}
		},
		"PAGE_NOT_FOUND": {
			"TITLE": {
				"fr": "Cette page n'existe pas",
				"en": "Page not found"
			},
			"CONTENT": {
				"fr": "",
				"en": ""
			}
		}
	},
	"HOME": {
		"CATALOGUE_GO": {
			"fr": "Voir le catalogue",
			"en": "Go to the catalogue"
		},
		"LATEST_RELEASES": {
			"fr": "Dernières publications",
			"en": "Latest releases"
		},
		"LATEST_RELEASES_SUB": {
			"fr": "Les derniers disques au catalogue",
			"en": "The latest in our catalogue"
		},
		"LATEST_RELEASES_GO": {
			"fr": "Voir les dernières publications",
			"en": "See the latest releases"
		},
		"SPECIALS": {
			"fr": "Forgotten Records présente",
			"en": "Forgotten Records presents"
		},
		"SPECIALS_SUB": {
			"fr": "Parmi les interprètes d'aujourd'hui",
			"en": "Some of our special releases"
		},
		"SPECIALS_GO": {
			"fr": "Voir davantage",
			"en": "See all the special releases"
		},
		"FEATURED": {
			"fr": "coup de cœur",
			"en": "featured"
		},
		"FEATURED_SUB": {
			"fr": "Nos recommandations du moment",
			"en": "What we are loving at the moment"
		}
	},
	"CATALOGUE": {
		"META": {
			"TITLE": {
				"fr": "Interprètes d'hier et d'aujourd'hui | Catalogue",
				"en": "Interpretations, past and present | Catalogue"
			}
		},
		"SEARCH": {
			"fr": "Rechercher",
			"en": "Search"
		},
		"NEW_SEARCH": {
			"fr": "Nouvelle recherche",
			"en": "New search"
		},
		"FILTERS": {
			"fr": "Filtres",
			"en": "Filters"
		},
		"FEATURED": {
			"fr": "Coup de coeur",
			"en": "Featured"
		}
	},
	"RECORD": {
		"ORIGINAL_REFERENCES": {
			"fr": "Edition originale",
			"en": "Original edition"
		},
		"LENGTH": {
			"fr": "Durée",
			"en": "Length"
		},
		"RECORDING": {
			"fr": "Enregistrement",
			"en": "Recording"
		},
		"DETAILS": {
			"fr": "Détails",
			"en": "Details"
		},
		"DESCRIPTION": {
			"fr": "Description",
			"en": "Description"
		},
		"RECOMMENDATION": {
			"fr": "Egalement par les mêmes interprètes",
			"en": "Featuring the same artists"
		}
	},
	"WRITING": {
		"FULL_TEXT_GO": {
			"fr": "Lire  le texte complet",
			"en": "Read the full text"
		},
		"AUTHOR_BY": {
			"fr": "par",
			"en": "by"
		},
		"NOT_TRANSLATED": {
			"fr": null,
			"en": "The full text has not been translated in English."
		},
		"READ_IN_PREFERRED_LANGUAGE": {
			"fr": "Lire en Français",
			"en": "Read in French"
		}
	},
	"CART": {
		"TITLE": {
			"fr": "Votre panier",
			"en": "Your cart"
		},
		"SHOW_ALL": {
			"fr": "Voir tout le panier",
			"en": "Show all items"
		},
		"GO": {
			"fr": "Accéder au panier",
			"en": "Go to your cart"
		},
		"EMPTY": {
			"fr": "Le panier est vide.",
			"en": "Your cart is currently empty."
		},
		"PROPERTY": {
			"PRICE": {
				"fr": "prix",
				"en": "price"
			},
			"QUANTITY": {
				"fr": "quantité",
				"en": "quantity"
			},
			"SUBTOTAL": {
				"fr": "sous-total",
				"en": "sub-total"
			},
			"TOTAL": {
				"fr": "total de la commande",
				"en": "total"
			},
			"SHIPPING": {
				"TITLE": {
					"fr": "Frais de livraison",
					"en": "Worldwide shipping"
				},
				"ONE": {
					"fr": "Premier disque",
					"en": "First item"
				},
				"OTHERS": {
					"fr": "Chaque disque supplémentaire",
					"en": "Each additional item"
				}
			}
		},
		"BACK": {
			"fr": "Revenir au catalogue",
			"en": "Back to catalogue"
		},
		"ADD": {
			"fr": "Ajouter au panier",
			"en": "Add to cart"
		},
		"DO_EMPTY": {
			"fr": "Vider le panier",
			"en": "Empty the cart"
		},
		"REMOVE": {
			"fr": "Retirer du panier",
			"en": "Remove from cart"
		},
		"WIDGET": {
			"NOTIFICATION": {
				"fr": "Le panier a été mis à jour",
				"en": "Your cart has been updated"
			}
		},
		"ORDER": {
			"TITLE": {
				"fr": "Confirmation de la commande",
				"en": "Order confirmation"
			},
			"MESSAGE": {
				"fr": "Vous recevrez d'ici peu un email de la part de notre partenaire.",
				"en": "You will receive a confirmation email very shortly."
			},
			"QUESTION": {
				"fr": "Pour toute question relative à cette commande, contactez-nous via",
				"en": "For any question about your order, feel free to contact us at"
			},
			"PAYMENT_ID": {
				"fr": "Identifiant du paiement",
				"en": "Payment ID"
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/app/app.intl.json
// module id = 463
// module chunks = 0